module.exports = __webpack_public_path__ + "static/media/tetrix_subulata.26b1fdab.jpg";